import { ProviderCredentialingCRUD } from '../../constants/api.config'
import getCharts from '../getCharts'

const escapeLegacyRequestValidationChars = (value) =>
  String(value || '').replace(/[<>&]/g, (char) => {
    switch (char) {
      case '<':
        return '\\u003c'
      case '>':
        return '\\u003e'
      case '&':
        return '\\u0026'
      default:
        return char
    }
  })

export default async function providerCredentialingCRUD(
  credentialData,
  credentialID = '',
  mode
) {
  try {
    const safeCredentialData = (() => {
      if (!credentialData) return '{}'

      if (typeof credentialData === 'string') {
        try {
          return escapeLegacyRequestValidationChars(
            JSON.stringify(JSON.parse(credentialData))
          )
        } catch {
          return '{}'
        }
      }

      try {
        return escapeLegacyRequestValidationChars(
          JSON.stringify(credentialData)
        )
      } catch {
        return '{}'
      }
    })()

    const payload = {
      credentialData: safeCredentialData,
      credentialID: String(credentialID || ''),
      mode: String(mode || '').toUpperCase(),
    }

    console.log('Provider Credentialing CRUD Payload:', payload)

    const res = await getCharts(ProviderCredentialingCRUD, payload)

    console.log('Provider Credentialing CRUD Response:', res)

    return res.data
  } catch (error) {
    console.error('ProviderCredentialingCRUD error:', error)
    return error
  }
}
